import { graphql } from 'gatsby';
import React from 'react';
import './multiColumnText.scss';

interface Props {
  columns: {
    title?: string;
    text?: string;
  }[];
}

const MultiColumnText: React.FC<Props> = (props) => {
  return (
    <div className="multi-column-text grid md:grid-cols-3 gap-x-32 gap-y-12 my-10">
      {props.columns.map((column, key) => (
        <div key={key}>
          {!!column.title && <h4>{column.title}</h4>}
          {!!column.text && <p>{column.text}</p>}
        </div>
      ))}
    </div>
  );
};

export default MultiColumnText;

export const query = graphql`
  fragment MultiColumnTextBlock on WpAcfMulticolumntextBlock {
    AcfMultiColumnText {
      columns {
        title
        text
      }
    }
  }
`;
